// import React, { useState } from 'react';
// import { useAuth } from '../../context/AuthContext';
// import { useNavigate } from 'react-router-dom';

// const Navbar = () => {
//     const [open,setOpen]=useState(false)
//   const { user, logout } = useAuth();
//   const navigate=useNavigate();

//   const handleLogout = () => {
//     // Replace with your auth logic
//    logout();
//    navigate("/login")
//   };

//   return (
//     <div style={{
//       padding: 20,
//       backgroundColor: '#fff',
//       display: 'flex',
//       justifyContent: 'space-between',
//       borderBottom: '1px solid #ccc',
//       position: 'relative',
//     }}>
//       <div></div>
//       <div style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
//         👤 Admin ▾
//         {open && (
//           <div style={{
//             position: 'absolute',
//             right: 20,
//             top: 60,
//             backgroundColor: 'white',
//             boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//             padding: '10px 0',
//             borderRadius: 4,
//             zIndex: 999,
//           }}>
//             <button
//               onClick={handleLogout}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 padding: '10px 20px',
//                 width: '100%',
//                 textAlign: 'left',
//                 cursor: 'pointer',
//                 color:'black'
//               }}
//             >
//               Logout
//             </button>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Navbar;

import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const Navbar = ({ onToggleSidebar, isMobile }) => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div
      style={{
        padding: "12px 20px",
        backgroundColor: "#fff",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #ccc",
        position: "relative",
        zIndex: 10,
      }}
    >
      {/* Left side – Hamburger (mobile only) */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {isMobile && (
          <button
            onClick={onToggleSidebar}
            style={{
              background: "none",
              border: "none",
              fontSize: 24,
              cursor: "pointer",
              padding: "4px 8px",
              lineHeight: 1,
              color: "#2c3e50",
            }}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        )}
      </div>

      {/* Right side – User dropdown (unchanged logic) */}
      <div
        style={{ cursor: "pointer", position: "relative" }}
        onClick={() => setOpen(!open)}
      >
        👤 Admin ▾
        {open && (
          <div
            style={{
              position: "absolute",
              right: 0,
              top: 40,
              backgroundColor: "white",
              boxShadow: "0 0 10px rgba(0,0,0,0.2)",
              padding: "10px 0",
              borderRadius: 4,
              zIndex: 999,
              minWidth: 140,
            }}
          >
            <button
              onClick={handleLogout}
              style={{
                background: "none",
                border: "none",
                padding: "10px 20px",
                width: "100%",
                textAlign: "left",
                cursor: "pointer",
                color: "black",
              }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
